import {BrowserAuthError, InteractionRequiredAuthError, InteractionStatus} from '@azure/msal-browser'
import {loginRequest} from '../auth/auth-config'

export const getAccessToken = async (instance, accounts, inProgress) => {
  const accessTokenRequest = {
    scopes: loginRequest.scopes,
    account: accounts[0]
  }
  if (accounts[0] && inProgress === InteractionStatus.None) {
    try {
      const response = await instance.acquireTokenSilent(accessTokenRequest)
      return response.accessToken
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        instance.acquireTokenRedirect(accessTokenRequest)
      } else if (error instanceof BrowserAuthError) {
        instance.acquireTokenRedirect(loginRequest)
      }
    }
  } else if (!accounts[0] && inProgress === InteractionStatus.None) {
    instance.acquireTokenRedirect(loginRequest)
  }
  return null
}
